export default "__VITE_ASSET__CDweoH$i__"